import { Component, OnInit } from '@angular/core';
import { UserService, fiatPayload } from "../services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import { AdminService } from "../services/admin.service";
import { WalletsService } from "../services/wallets.service";
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';


@Component({
    selector: 'app-admin-transactions',
    templateUrl: './admin-transactions.component.html',
    styleUrls: ['./admin-transactions.component.css']
})
export class AdminTransactionsComponent implements OnInit {

    buttondisable = 'false';
    allWallets = [];
    wallets = [];
    tranobj: any = {
        name: '',
        wallet: '',
        userid: '',
        amount: 0,
        txnid: '',
        transaction_type: 'Deposit',
        wallet_type: 'USER',
        transaction_date: '',
        note: '',

    };
    errorObj = {
        name: '',
        wallet: '',
        userid: '',
        amount: '',
        txnid: '',
    }
    permission: string;
    id: any;
    constructor(private router: Router, private userService: UserService,
        private notifSer: NotificationsService,
        private walletsService: WalletsService,
        private route: ActivatedRoute,
        private adminService: AdminService,
        private _location: Location,) { }

    ngOnInit() {
        // Set the default transaction date to today's date
        this.tranobj.transaction_date = new Date().toISOString().split('T')[0];

        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.id = this.route.snapshot.paramMap.get('id');

            if (typeof this.id !== 'undefined' && this.id) {
                this.tranobj.userid = this.id;
                this.getWalletsList(this.id)
            }
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            });
            this.permission = this.adminService.getPermission();
            this.csrf();
        }
    }

    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.tranobj._csrf = success._csrf;
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    getWalletsList(id) {
        this.walletsService.getWalletsList(id).subscribe(res => {
            this.allWallets = [];
            this.wallets = [];
            this.allWallets = res.sort((a, b) => a.currency > b.currency ? 1 : -1);
            this.wallets = this.allWallets.filter(data => data.walletType === this.tranobj.wallet_type);
            if (this.wallets.length > 0) {
                this.tranobj.wallet = this.wallets[0]._id;
            }else {
                this.tranobj.wallet = '';
            }
        })
        this.userService.getCustomerDetailsById(id).subscribe(done => {
            this.tranobj.name = done.name;
        });
    }

    filterWalletType(walletType: string){
        this.wallets = [];
        this.wallets = this.allWallets.filter(data => data.walletType === walletType);
        if (this.wallets.length > 0) {
            this.tranobj.wallet = this.wallets[0]._id;
        } else {
            this.tranobj.wallet = '';
        }
    }

    clearError(field) {
        switch (field) {
            case 'name':
                this.errorObj.name = '';
                break;
            case 'wallet':
                this.errorObj.wallet = '';
                break;
            case 'amount':
                this.errorObj.amount = '';
                break;
            case 'txnid':
                this.errorObj.txnid = '';
                break;
        }
    }

    validateNumber(e: any) {
        var input = e.target.value;
        var id = e.target.id;
        var test = input.split(".");

        if (test.length > 0) {
            if (typeof test[1] != 'undefined' && test[1].length >= 8) {
                this.notifSer.error(
                    'Error',
                    'Max decimal Limit is 8',
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
                e.preventDefault();
            }
        }
    }

    updateBalance(signup: NgForm) {
        if (this.tranobj.amount <= 0) {
            this.notifSer.error(
                'Error',
                "Please enter valid Amount",
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            return false;
        }
        else {
            this.buttondisable = 'true';
            this.userService.csrf().subscribe((success) => {
                this.tranobj._csrf = success._csrf;

                if(this.tranobj.transaction_type == 'Deposit'){
                    this.userService.addBalance(this.tranobj).subscribe((success) => {
                        if (success.status) {
                            this.tranobj.amount = 0;
                            this.tranobj.txnid = ' ';
                            this.tranobj.note = '';
                            this.notifSer.success(
                                'Success',
                                success.message,
                                {
                                    timeOut: 3000,
                                    showProgressBar: true,
                                    pauseOnHover: false,
                                    clickToClose: true,
                                    maxLength: 50
                                }
                            )
                            this.buttondisable = 'false';
    
                        }
                    });
                }else if(this.tranobj.transaction_type == 'Withdraw'){
                    this.userService.reduceBalance(this.tranobj).subscribe((success) => {
                        if (success.status) {
                            this.tranobj.amount = 0;
                            this.tranobj.txnid = '';
                            this.tranobj.note = '';
                            this.notifSer.success(
                                'Success',
                                success.message,
                                {
                                    timeOut: 3000,
                                    showProgressBar: true,
                                    pauseOnHover: false,
                                    clickToClose: true,
                                    maxLength: 50
                                }
                            )
                            this.buttondisable = 'false';
                        }
                        else {
                            this.notifSer.error(
                                'Error',
                                success.message,
                                {
                                    timeOut: 3000,
                                    showProgressBar: true,
                                    pauseOnHover: false,
                                    clickToClose: true,
                                    maxLength: 50
                                }
                            )
                            this.buttondisable = 'false';
                        }
                    });
                }

            }, (error) => {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            })
        }
    }

    back() {
        this._location.back();
    }
}



// WEBPACK FOOTER //
// ./src/app/admin-transactions/admin-transactions.component.ts